import { _makeFetch } from './_common.js';

function toJson(res) {
  return res.json();
}

function onError(error) {
  console.error(error);
  throw new Error('Error retrieving account information');
}

export function getAccountData() {
  return _makeFetch('/core/account/data', { credentials: 'include' })
    .then(toJson)
    .catch(onError);
}
